
import BForm from 'JS/components/blain-form/BForm.vue';
import BSelect from 'JS/components/blain-form/BSelect.vue';
import bugsnagClient from 'JS/global/bugsnag';
import Spinner from 'JS/components/Spinner.vue';
import TransitionExpand from 'JS/components/transitions/TransitionExpand.vue';
import UiButton from 'JS/components/UiButton.vue';
import Vue from 'vue';
import { Component, Inject, Watch } from 'vue-property-decorator';
import { ITireSizeLookupService } from '../services/TireSizeLookupService';

@Component({
	name: 'TireSizeLookupForm',
	components: {
		BForm,
		BSelect,
		UiButton,
		Spinner,
		TransitionExpand,
	}
})
class TireSizeLookupForm extends Vue {

	$refs!: {
		form: BForm;
	}

	@Inject('TireSizeLookupService')
	_sizeLookupService: ITireSizeLookupService;

	width: number = null;
	ratio: number = null;
	rimSize: number = null;
	widths: number[] = [];
	ratios: number[] = [];
	rimSizes: number[] = [];
	loading: boolean = false;
	error = null;

	/* Computed
	============================================*/

	get canSubmit(): boolean {
		return !!this.width && !!this.ratio && !!this.rimSize;
	}

	/* Methods
	============================================*/

	async mounted() {
		this.loadWidths();
	}

	async loadWidths() {
		this.handleSizeLookupCall(async () => {
			this.widths = await this._sizeLookupService.getSectionWidths();
		});
	}

	async loadRatios() {
		this.handleSizeLookupCall(async () => {
			this.ratios = await this._sizeLookupService.getAspectRatios(this.width);
			if (this.ratios.length === 1) {
				this.ratio = this.ratios[0];
			}
		});
	}

	async loadRimSizes() {
		this.handleSizeLookupCall(async () => {
			this.rimSizes = await this._sizeLookupService.getRimSizes(this.width, this.ratio);
			if (this.rimSizes.length === 1) {
				this.rimSize = this.rimSizes[0];
			}
		});
	}

	async handleSizeLookupCall(fn: (...args: any) => Promise<any>) {
		this.error = null;
		this.loading = true;
		try {
			await fn();
		} catch (e) {
			bugsnagClient.notify(e, {
				metaData: {
					info: 'Failed to fetch tire size data',
				}
			});
		} finally {
			this.loading = false;
		}
		this.$refs.form.resetValidation();
	}

	/* Watchers
	============================================*/

	@Watch('width')
	onWidthChange() {
		this.ratio = null;
		this.rimSize = null;
		if (!this.width) return;
		this.loadRatios();
	}

	@Watch('ratio')
	onRatioChange() {
		this.rimSize = null;
		if (!this.width || !this.ratio) return;
		this.loadRimSizes();
	}
}

export default TireSizeLookupForm;
